import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import PatientMedicineServiceModal from "./PatientMedicineServiceModal";
import { Button, Checkbox, Input, Select, Textarea, TextareaWithSelectDosage } from "../Form";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllMedicamentos,
  getMedicamentos,
} from "../../redux/features/recetaSlice";
import api from "../../customHooks/queries/api";

function MedicineDosageModal({ closeModal, isOpen, setReceta }) {
  const [open, setOpen] = useState(false);
  // const [instraction, setInstraction] = useState(null);
  const [presentacion, setPresentacion] = useState(null);
  // const [cantidad, setCantidad] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // const [instructionsData, setInstructionsData] = useState([]);
  const [presentationsData, setPresentationsData] = useState([]);
  const [instructionsData, setInstructionsData] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: "",
      cantidad: "",
      instrucciones:""
    },
  });
  const dispatch = useDispatch();
  const medicamentos = useSelector(getAllMedicamentos);

  useEffect(() => {
    dispatch(getMedicamentos());
  }, [dispatch, medicamentos.length]);

  useEffect(() => {
    const fetchPresentations = async () => {
      const { data } = await api.get(`/api/v1/parametros/RECETA/PRESENTACION`);
      const dataModificada = data.map(param => {
        return {
            id: param.id,
            name: param.valor
        };
      });
      setPresentationsData(dataModificada);
      setPresentacion(dataModificada[0]);
    };

    fetchPresentations();
  }, []);

  useEffect(() => {
    const fetchInstrucciones = async () => {
      const { data } = await api.get(`/api/v1/instrucciones`);
    
      const instruccionesModificadas = data.map(param => {
        return {
          id: param.id,
          name: param.name,
          selected: false
        }; 
      });
      instruccionesModificadas.unshift({name: "Ninguno"});
      setInstructionsData(instruccionesModificadas);
    }
    fetchInstrucciones();
  }, []);
  
  const handleAgregar = (body) => {
    setReceta((receta) => [
      ...receta,
      {
        nombre: body.nombre,
        instrucciones: body.instrucciones,
        presentacion: presentacion.name,
        cantidad: body.cantidad,
      },
    ]);
    closeModal();
  };
  const handleChange = (e) => {
    let filtered = medicamentos.filter((item) =>
      item.name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    if (filtered.length > 10) filtered = filtered.slice(0, 10);

    if (e.target.value.length === 0) {
      setFilteredData(medicamentos.slice(0, 10));
    } else setFilteredData(filtered);
  };
  return (
    <>
      {open && (
        <PatientMedicineServiceModal
          closeModal={() => setOpen(!open)}
          isOpen={open}
          patient={false}
        />
      )}
      <Modal
        closeModal={closeModal}
        isOpen={isOpen}
        title="Agregar Medicamento a Prescripción"
        width={"max-w-xl"}
      >
        <div className="flex-colo gap-6">
          {/* title */}
          <div className="w-full">
            <Input
              label="Medicamento"
              color={true}
              register={register("nombre", {
                required: "Introduzca el nombre.",
                onChange: (e) => handleChange(e),
                onBlur: () => setFilteredData([]),
                onMouseDown: (e) => handleChange(e),
              })}
              type={"text"}
              error={errors.nombre}
            />

            {filteredData?.length > 0 && (
              <ul className="max-h-40 w-full sm:w-1/2 border absolute  rounded-lg z-50 bg-white overflow-y-scroll">
                {filteredData?.map((item) => (
                  <li
                    key={item.id}
                    onMouseDown={() => {
                      setValue("nombre", item.name);
                      setTimeout(setFilteredData([]), 400);
                    }}
                    className="border-b py-2 px-5"
                  >
                    {`${item.name}`}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="flex w-full flex-col gap-3">
            <p className="text-black text-sm">Presentación</p>
            <Select
              selectedPerson={presentacion}
              setSelectedPerson={setPresentacion}
              datas={presentationsData}
            >
              <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                {presentacion?.name} <BiChevronDown className="text-xl" />
              </div>
            </Select>
          </div>

          <Input
            label="Cantidad"
            color={true}
            register={register("cantidad", {
              required: "Introduzca la cantidad.",
              min: { value: 1, message: "La cantidad debe ser mayor a 0" },
            })}
            type={"number"}
            error={errors.cantidad}
          />

          <TextareaWithSelectDosage
						label="Instrucciones"
						color={true}
						register={register}
						name="instrucciones"
						setValue={setValue}
						getValue={getValues}
						datas={instructionsData}
            error={errors.instrucciones}
					/>

          <Button
            onClick={handleSubmit(handleAgregar)}
            label="Agregar"
            Icon={BiPlus}
          />
        </div>
      </Modal>
    </>
  );
}

export default MedicineDosageModal;